import type { Middleware } from "@reduxjs/toolkit";
import { isAction } from "@reduxjs/toolkit";
import { vscsHubConnection } from "~/vscsHubConnection";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const vscsMiddleware: Middleware<Record<never, never>, any> =
  () => (next) => (action) => {
    const result = next(action);
    if (
      isAction(action) &&
      !(action as { meta?: { forwarded?: boolean } }).meta?.forwarded &&
      vscsHubConnection.isActive &&
      vscsHubConnection.socket?.connected
    ) {
      vscsHubConnection.sendUiAction(action);
    }
    return result;
  };
